export const getModuleNotices = (state) => state.notices

